import ModalComponet, { ModalAlertTitle, ModalFooter } from "@components/modal";
import { Button } from "@fc/devteam-components-library";
import { useTranslation } from "react-i18next";

export default function AlertFinishSession(props: {open: boolean, onClose: () => void, action: () => void}) {
    const { t } = useTranslation(['common']);

    return(
        <ModalComponet open={props.open} onClose={props.onClose}>
            <>
            <ModalAlertTitle label={t('alerts.session.expired.title')} />
                <div className="Services__TextDivider">
                    <p className="Services__InputLabel-R">
                        {t('alerts.session.expired.text')}
                    </p>
                </div>
            <ModalFooter>
                <>
                <Button
                    buttontype='button'
                    buttontext={t('alerts.session.expired.buttons.continue')}
                    action={props.onClose}
                />
                <Button
                    buttontype='button'
                    buttontext={t('alerts.session.expired.buttons.logout')}
                    action={() => props.action()}
                />
                </>
            </ModalFooter>
            </>
        </ModalComponet>
    )
}